<template>
  <v-card flat>
    <v-autocomplete box multiple clearable chips :menu-props="{maxHeight: 450}" label="Monitoring Component" v-model="selectedCategories" :items="stationCategoriesNameList" @change="handleUpdateFilters($event)" />
  </v-card>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    StationCategoryFilter,
  } from '@/components/plugins/DataSetFilter'

  const datasetfilter = createNamespacedHelpers('datasetfilter')
  const stations = createNamespacedHelpers('stations')

  export default {
    data() {
      return {
        selectedCategories: [],
      }
    },
    computed: {
      ...stations.mapGetters(['stationCategories']),
      ...datasetfilter.mapGetters(['getFilter']),
      stationCategoriesNameList() {
        if (!Array.isArray(this.stationCategories)) {
          return []
        } else {
          return this.stationCategories
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map(e => e.Name)
        }
      },
      selectedCategoriesFromStore() {
        return this.getFilter('station-category').map(f => f.toString())
      },
    },
    watch: {
      selectedCategoriesFromStore(newCategoryList) {
        this.selectedCategories = newCategoryList
      },
    },
    methods: {
      ...datasetfilter.mapActions(['addFilter', 'updateFilterListByType']),

      handleUpdateFilters(filterStrings) {        
        let filterList = filterStrings.map(
          f => new StationCategoryFilter(f)
        )
        this.updateFilterListByType({
          filterType: 'station-category',
          filters: filterList,
        })
        this.$emit('instantSearchEvent', 'station-category')
      },
      handleReturn() {
        this.$emit('returnEvent', 'station-category')
      },
      clearForm() {
        this.selectedCategories = []
      },
    },
  }
</script>

<style>
  .solo-select {
    border: 1px solid #ddd;
  }
</style>